/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-container[_ngcontent-%COMP%]{background-color:#edf6ff;margin-bottom:32px}"];
export { styles as styles };
//# sourceMappingURL=videos-carousel.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/videos-carousel/videos-carousel.component.scss.shim.ngstyle.js
// module id = 1639
// module chunks = 27 28 29